import { ProductFamiliesThemeModeConfig } from './types';

const light: ProductFamiliesThemeModeConfig = {
  productFamilies: {
    backgroundColor: '#ffffff',
    backgroundGradient: 'linear-gradient(to bottom, #33adff11, #ffffff)',
    cardBackgroundGradient: 'linear-gradient(to bottom, #33adff55, #0000FF22)',
    hoverBackgroundGradient: 'linear-gradient(to bottom, #33adff99, #0000FF22)',
    borderColor: ' #0775bc ',
    boxShadow: '0 8px 12px 0 #80ccff, 0 8px 12px #33adff, 8px 10px 12px 0 #33adff',
    textColor: '#444444',
    labelBGColor: '#50521120',
    normalButtonBGColor: '#0775bc',
    normalButtonBorderColor: '2px solid #267DAC',
  },
};

export default light;
